export const BUYER_VIEWED_REPORT = 'buyer-viewed-report'
export const BUYER_VIEWED_MARKETS = 'buyer-viewed-markets'
